'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _skinnable = require('revenge/lib/decorators/skinnable');

var _skinnable2 = _interopRequireDefault(_skinnable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _skinnable2.default;